<template>
  <section id="section-3" class="content-current-tab">
    <div v-if="!isLoading">
      <div class="row">
        <div class="col-md-11"></div>
        <div class="col-md-1">
          <router-link to="/profile/dashboard">
            <div title="بازگشت به داشبورد" class="close"></div>
          </router-link>
        </div>
      </div>
      <form method="Post">
        <div style="text-align:center height: 50px;" class="row notification notification-success" role="alert">
          <div class="col-md-6">
            اعتبار
            <span style="color: #178a00; font-weight: bold">
              {{ sourceName }} </span>:
            <span style="margin-right: 10px; font-size: 18px">
              {{ GetSourceDeposit | numFormat }} ريال</span>
          </div>
          <div class="col-md-6">
            <!-- اعتبار همه کسب و کارها :
          <span style="margin-right: 10px; font-size: 18px"
            >{{ GetSumDeposit | numFormat }} ريال</span
          > -->
          </div>
        </div>
        <hr />

        <!-- <div class="row">
        <div class="col-md-6">
          <label> آژانس</label>
          <div class="styled-select select">
            <select v-model="selectedSource" @change="onChange($event)">
              <option
                v-for="item in sources"
                :value="{ id: item.id, name: item.name }"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
      </div> -->

        <div class="row">
          <div class="col-md-6">
            <div class="group_mdi">

              <currency-input @blur="$v.amount.$touch()" v-model="amount" currency="IRR" locale="fa" />
              <span class="highlight"></span><span class="bar"></span>
              <label><span class="validation-color">*</span>مبلغ </label>
              <p class="text-danger" v-if="!$v.amount.required && $v.amount.$dirty">
                لطفا مبلغ را وارد نمائید
              </p>
              <p class="text-danger" v-if="!$v.amount.price_greater && $v.amount.$dirty">
                حداقل مبلغ افزایش اعتبار 10,000 ريال می باشد
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-inline">
              <div class="form-group" v-for="(item, index) in ipgList" :key="item.id">
                <label class="form-check-label pointer-bank">
                  <input type="radio" class="form-check-input radio-btn" v-model="selectedBank" :value="item.bank.id" />

                  <span class="radio-title">{{ item.bank.title }} </span>

                  <img style="margin-left: 40px" height="40" width="40" v-if="item.bank.logo"
                    :src="'data:image/jpeg;base64,' + item.bank.logo" class="card bg-white img-size" />
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-align">
          <button type="submit" class="btn-profile" @click.prevent="increaseDeposit" :disabled="$v.$invalid"
            :class="{ disabledBtn: $v.$invalid }">
            افزایش اعتبار
          </button>
        </div>
        <div class="notofication">
          <p style="color: red">
            لطفاً هنگام افزایش اعتبار نکات زیر را رعایت فرمایید:
          </p>
          <p>1- حداقل مبلغ هر تراکنش 10,000 ريال می باشد.</p>
          <p>
            2- در هنگام انجام تراکنش به هیچ عنوان از نرم افزارهای فیلترشکن و یا
            VPN استفاده نفرمایید.
          </p>
          <p>
            3- در صورتی که پس از انجام تراکنش و کسر مبلغ آن از حساب شما "اعتبار"
            شما شارژ نشد، مبلغ تراکنش در اسرع وقت به صورت خودکار (توسط سیستم
            بانکی) به حساب شما بازگردانده خواهد شد.
          </p>
        </div>
      </form>
    </div>
    <div v-else>
      <PdkBankLoading v-if="isLoading" />
    </div>
  </section>
</template>

<script>
import Store from "../../../views/tourism/store/index";
import { required } from "vuelidate/lib/validators";
import PdkBankLoading from "../../../components/loading/PdkBankLoading.vue";
import uri from "../../../../public/publicUries";

export default {
  name: "creditReport",
  store: Store,
  components: { PdkBankLoading },
  validations: {
    selectedBank: { required },
    amount: {
      required,
      price_greater: (value) => value >= 10000,
    },
  },
  data() {
    return {
      isLoading: false,
      amount: null,
      value: "",
      ipgList: [],
      selectedBank: 1,
      selectedSource: "",
      sourceName: "",
      sources: [],
      tourismType: 1,
    };
  },
  computed: {
    GetSumDeposit() {
      return this.$store.getters.GetSumDeposit;
    },
    GetSourceDeposit() {
      return this.$store.getters.GetSelectedSourceDeposit;
    },
  },
  created() {
    this.getTourismType();

    if (this.tourismType === 2) this.getAllIpgFastTrack();
    else this.getAllIpgDolphin();

    // this.getSources();
    this.sourceName = localStorage.getItem("SourceNameInReport");
  },
  methods: {
    getTourismType() {
      const tourismType = this.$route.params.tourismType;
      if (tourismType === "fastTrack") this.tourismType = 2;
      else this.tourismType = 1;
    },
    getSources() {
      this.sources = this.$store.getters.GetAllSourceConfirmed;
    },
    onChange(event) {
      this.$store.commit(
        "SetSelectedSourceDeposit",
        this.sources.filter((p) => p.id == this.selectedSource.id)[0].deposit
      );
      this.sourceName = this.selectedSource.name;
    },
    async getAllIpgFastTrack() {
      this.$store.dispatch("getIPGs").then((res) => {
        this.ipgList = res.data;
        this.selectedBank = this.ipgList[0].bankId;
      });
    },
    async getAllIpgDolphin() {
      this.$store.dispatch("getIPGsDolphin").then((res) => {
        this.ipgList = res.data;
        this.selectedBank = this.ipgList[0].bankId;
      });
    },
    async increaseDeposit() {
      if (this.tourismType === 2) this.increaseDepositFastTrack();
      else this.increaseDepositDolphin();
    },
    async increaseDepositFastTrack() {
      this.isLoading = true;
      const paymentModel = {
        payRequestId: "",
        saleReferenceId: "",
        saleOrderId: this.GeneratePaymentOrderId(),
        amount: parseInt(this.amount),
        extensionData: "",
        bankId: this.selectedBank,
      };
      const data = {
        sourceId: localStorage.getItem("SourceIdInReport"),
        userId: 0,
        sourceProfileId: localStorage.getItem("SourceProfileId"),
        updateCreditUrl: uri.updateCreditUrl,
        successCallBackUrl: uri.increaseDepositCallBackUrl,
        errorCallBackUrl: uri.increaseErrorCallBackUrl,
        paymentModel: paymentModel,
      };
      const res = await this.$store.dispatch("increaseDeposit", data);
      if (res.status == 200) {
        if (res.data.data[0].errorCode === "0") {
          window.location.href =
            res.data.data[0].bankUrl + res.data.data[0].refrenceId;
        } else {
          // alert(res.data.data[0].errorText);
          this.$toast.error(res.data.data[0].errorText, {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
        }
      } else {
        this.isLoading = false;
        // alert("خطا در اتصال به بانک!!!");
        this.$toast.error("خطا در اتصال به بانک!!!", {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });
      }
      this.isLoading = false;
    },
    async increaseDepositDolphin() {
      this.isLoading = true;
      const paymentModel = {
        payRequestId: "",
        saleReferenceId: "",
        saleOrderId: this.GeneratePaymentOrderId(),
        amount: parseInt(this.amount),
        extensionData: "",
        bankId: this.selectedBank,
      };
      const data = {
        sourceId: localStorage.getItem("SourceIdInReport"),
        userId: 0,
        sourceProfileId: localStorage.getItem("SourceProfileId"),
        updateCreditUrl: uri.updateCreditUrl,
        successCallBackUrl: uri.increaseDepositCallBackUrl,
        errorCallBackUrl: uri.increaseErrorCallBackUrl,
        paymentModel: paymentModel,
      };
      const res = await this.$store.dispatch("increaseDepositDolphin", data);
      if (res.status == 200) {
        if (res.data.data[0].errorCode === "0") {
          window.location.href =
            res.data.data[0].bankUrl + res.data.data[0].refrenceId;
        } else {
          // alert(res.data.data[0].errorText);
          this.$toast.error(res.data.data[0].errorText, {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
        }
      } else {
        this.isLoading = false;
        // alert("خطا در اتصال به بانک!!!");
        this.$toast.error("خطا در اتصال به بانک!!!", {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });
      }
      this.isLoading = false;
    },
    GeneratePaymentOrderId() {
      const random = Math.floor(100000 + Math.random() * 900000);
      let inBoundorderId = parseInt("98" + random);
      return inBoundorderId;
    },
  },
};
</script>

<style scoped lang="scss">
.doc-page>div,
.doc-page>pre {
  margin-bottom: 22px;
}

.doc-note--tip {
  background-color: #c1f4cd !important;
  border-color: #00a65a !important;
  /* color:#777777; */
}

.doc-note {
  background-color: #eee;
  border-radius: 4px;
  margin: 16px 0;
  padding: 14px 124px;
  font-size: 1em;
  border-width: 0 10px;
  border-style: solid;
  border-color: #9e9e9e;
  letter-spacing: 0.5px;
  font-size: 18px;
  width: 100%;
}

.notofication {
  margin: 40px 0px 70px 0px;
}

.radio-margin {
  margin-left: 30px;
}

.img-size {
  width: 30px;
  height: 30px;
}

$notification-spacer-y: 1rem;

$notification-padding-y: 0.5rem;
$notification-padding-x: 0.75rem;

$notification-border-width: 0.0625rem;
$notification-border-radius: 0.25rem;

$notification-font-size: 1rem;
$notification-line-height: 1.5rem;

// Colors
$notification-primary-color: silver;
$notification-error-color: tomato;
$notification-warning-color: gold;
$notification-info-color: skyblue;
$notification-success-color: silver;

// Types
$notification-types: (
  "error": $notification-error-color,
  "warning": $notification-warning-color,
  "info": $notification-info-color,
  "success": $notification-success-color,
);

/**
 * Notification mixins
 * =============================================================================
 */
@mixin notification-type($color) {
  color: mix($color, black, 8% * 3);
  background-color: lighten($color, 8% * 2);
  border-color: darken($color, 8%);
}

/**
 * Notification
 * @requires close
 * @requires notification.variables
 * @requires notification.mixins
 * {@link https://codepen.io/belyan/full/odLorq/ Examples}
 * =============================================================================
 */
.notification {
  position: relative;
  padding: $notification-padding-y $notification-padding-x;

  border: $notification-border-width solid transparent;
  border-radius: $notification-border-radius;

  font-size: $notification-font-size;
  line-height: $notification-line-height;

  &+& {
    margin-top: $notification-spacer-y;
  }

  @include notification-type($notification-primary-color);

  @each $type,
  $color in $notification-types {
    &-#{$type} {
      @include notification-type($color);
    }
  }

  &-heading {
    color: inherit;
    line-height: inherit;
  }

  &-closable {
    // padding-right: ($close-font-size + $notification-padding-x * 2);

    // Adjust close link position
    .close {
      position: absolute;
      top: 0;
      right: 0;
      padding: $notification-padding-y $notification-padding-x;
      color: inherit;
    }
  }
}

// Override styles from github markdown
.notification h4 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

.notification p {
  margin-bottom: 0;
}

.radio-margin {
  margin-left: 30px;
}

.form-check-input {
  margin-left: 5px;
}

.radio-title {
  margin-left: 20px;
}

.radio-btn {
  display: block;
  position: relative;

  margin-bottom: 12px;
  cursor: pointer;
  font-size: 13px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-btn input {
  position: absolute;
  opacity: 1;
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03) !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.card-sendanyway {
  padding: 0.1rem 1.25rem;
  margin-bottom: 0;
  background-color: rgb(42, 105, 177) !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  color: #fff;
  margin-top: 20px !important;
  font-size: 16px;
  width: 100%;
  margin: 20px 70px 0px 70px;
  border-radius: 3px;
}

.pointer-bank {
  cursor: pointer;
}
</style>